import _ from 'lodash';

const { Customer, Order, UI } = Mobi2Go;

const promptToJoinLoyaltyClub = () => {
    if (
        Order.getProgressPhase() === 'unconfirmed' &&
        Customer.shouldPromptToJoinLoyaltyClub()
    ) {
        _.delay(function() {
            UI.trigger('showLoyaltyClubForm');
        }, 1250);
    }
};

const promptToSelectDeliveryAddress = () => {
    const customer = Order.getCustomer();
    const method = Order.getMethod();
    const address = Order.getAddress();

    if (customer && !customer.is_guest && method === 'delivery' && !address) {
        setTimeout(() => Mobi2Go.UI.trigger('showCustomerAddresses'), 500);
    }
};

const onCustomerLogIn = () => {
    Order.onReady(() => {
        promptToJoinLoyaltyClub();
    });
};

const onCustomerUpdate = () => {
    Order.setCustomer(Customer.get());
};

Customer.bind({
    logIn: onCustomerLogIn,
    update: onCustomerUpdate,
});

const onCompleteVerification = () => {
    promptToJoinLoyaltyClub();
};

UI.bind({ smsVerificationCompleted: onCompleteVerification });

const onUpdateOrderCustomer = () => {
    promptToSelectDeliveryAddress();
};

const onUpdateOrderMethod = () => {
    promptToSelectDeliveryAddress();
};

Order.bind({
    updateCustomer: onUpdateOrderCustomer,
    updateMethod: onUpdateOrderMethod,
});
